import BicycleHero from 'assets/images/psp/hero/bicycle-hero.webp';
import cameraIcon from 'assets/images/icons/psp/camera.svg';
import weatherIcon from 'assets/images/psp/six.svg';
import garageicon from 'assets/images/psp/amenities/garage.svg';
import twentyFourHourIcon from 'assets/images/psp/amenities/24-hour.svg';
import paperIcon from 'assets/images/psp/amenities/paperwork.svg';
import renovatingIcon from 'assets/images/icons/psp/renovating.svg';
import bicycleFiveByFive from 'assets/images/psp/bicycleSizeGuide/bicycle-5x5.svg';
import bicycleFiveByTen from 'assets/images/psp/bicycleSizeGuide/bicycle-5x10.svg';
import bicycleTenByTen from 'assets/images/psp/bicycleSizeGuide/bicycle-10x10.svg';
import bicycleFeatured1 from 'assets/images/psp/FeaturedImages/bicycle-1.webp';
import bicycleFeatured2 from 'assets/images/psp/FeaturedImages/bicycle-2.webp';
import bicycleFeatured3 from 'assets/images/psp/FeaturedImages/bicycle-3.webp';

const reviews = [
	{
		reviewTitle: 'Good service, easy.',
		reviewRating: 5,
		reviewText:
			'Thanks for helping me. I found a place to store my bike in minutes.',
		reviewerInitials: 'GG',
		link: 'https://www.trustpilot.com/reviews/563cb7c00000ff000917b4b7',
		reviewerName: 'Gabriel Gagne',
		reviewDate: 'Nov 6, 2015',
	},
	{
		reviewTitle: 'I was looking for storage space and…',
		reviewRating: 5,
		reviewText:
			'I was looking for storage space and assumed further from the city would be less expensive. SpareFoot found the perfect space at 30% lower cost - and closer!',
		reviewerInitials: 'DT',
		link: 'https://www.trustpilot.com/reviews/625adf0a2b3c3c43cfd48826',
		reviewerName: 'Debra Thompson',
		reviewDate: 'Apr 16, 2022',
	},
	{
		reviewTitle: 'First space I found on a search for college storage…',
		reviewRating: 5,
		reviewText:
			'Love the online availability to reserve and also change, as we are dealing with college kids whose schedules change, and the size of storage needs change. Dates are constantly evolving for move-ins, and sometimes an added friend needs to store their bike or couch. Very easy to alter or cancel reservations and book a more appropriate one.',
		reviewerInitials: 'CA',
		link: 'https://www.trustpilot.com/reviews/5369b90b0000640002884531',
		reviewerName: 'campustrips',
		reviewDate: 'May 7, 2014',
	},
	{
		reviewTitle: '#1 for storage units in your area.',
		reviewRating: 5,
		reviewText:
			"This site lets you see the storage units available in your area, with accurate prices. It doesn't take you to another site that doesn't even deal with storage places in your city. This has been my go-to site, and I've told sooooo many people about it.",
		reviewerInitials: 'EM',
		link: 'https://www.trustpilot.com/reviews/5f741163798e6f0960233b86',
		reviewerName: 'Emily McVay',
		reviewDate: 'Sep 30, 2020',
	},
];

const faqs = [
	{
		question: 'Can you store a bicycle in a storage unit?',
		answer:
			'Yes. Storing your bicycle in a storage unit is an excellent solution for cyclists who lack adequate home storage space. Most storage facilities welcome bicycles, and many offer specialized bike storage options. The key is selecting the right size unit – typically, [a 5x5 works for a single bike](https://www.sparefoot.com/blog/5x5-storage-unit-size-guide) with accessories, while multiple bikes or extensive gear might require a 5x10 or larger unit.\n\n' +
			'Indoor bicycle storage units provide the best protection from weather, theft, and vandalism. Your bike will stay clean, dry, and secure between rides. Many facilities also offer climate-controlled options for premium protection, which is especially valuable for high-end carbon fiber bikes or vintage bicycles.\n\n' +
			"When choosing a storage facility, look for features like wide access doors (for easy bike maneuvering), good security measures, and convenient access hours. Some facilities even offer outdoor storage lockers for bikes, which provide weather protection at a lower cost than indoor units. Always verify the facility's policies regarding bike storage and any insurance requirements.",
	},
	{
		question: 'Can you store two bikes in a 5x5 storage unit?',
		answer:
			"Yes, you can typically store two bikes in a 5x5 storage unit, but it depends on the size and type of bicycles you're storing. A 5x5 unit provides 25 square feet of floor space, which is generally sufficient for two standard road bikes, hybrid bikes, or mountain bikes when positioned strategically.\n\n" +
			'The key to maximizing space in a 5x5 unit is smart positioning and potentially using vertical storage methods. You can hang one or both bikes on wall hooks, use bike stands to keep them upright, or lean them against walls. Standard adult bikes are typically 5-6 feet long, so with careful arrangement, two bikes can fit comfortably with some room left over for accessories.\n\n' +
			'However, certain bike types might be more challenging to fit. Fat bikes, cargo bikes, or bikes with extensive accessories like baskets, child seats, or panniers may require more space. Similarly, if you have very tall bikes or want to store additional gear like helmets, locks, tools, or seasonal equipment, you might find the space tight.\n\n' +
			"Consider your access needs as well. While two bikes can physically fit in a 5x5 unit, you'll want to ensure you can easily retrieve either bike without having to move the other one around. If you access your bikes frequently or have bikes of significantly different sizes, you might find a [5x10 unit more practical](https://www.sparefoot.com/blog/5x10-storage-unit-size-guide) for the extra maneuvering room and storage for cycling accessories.",
	},
	{
		question: 'What size storage unit do I need to store my bicycle?',
		answer:
			"The size storage unit you need depends on how many bikes you're storing, their types, and what additional gear you want to keep with them. For most cyclists, the sweet spot falls between a 5x5 and 5x10 unit, but your specific needs will guide the best choice.\n\n" +
			"A 5x5 storage unit (25 square feet) works well for one to two standard bikes with basic accessories. This size accommodates most road bikes, mountain bikes, or hybrid bikes, plus space for helmets, locks, and basic maintenance supplies. It's the most cost-effective option for casual cyclists or those with limited storage needs.\n\n" +
			"If you have multiple bikes, extensive gear, or larger bicycles, consider a 5x10 unit (50 square feet). This size comfortably fits 2-4 bikes, depending on their size, plus ample room for cycling accessories, tools, seasonal gear, and maintenance equipment. It's ideal for cycling enthusiasts or families with multiple bikes.\n\n" +
			'For serious collectors or those with specialized equipment, a [10x10 unit (100 square feet) provides space for larger collections](https://www.sparefoot.com/blog/10x10-storage-unit-size-guide), bike maintenance areas, and extensive gear storage. This size works well for cyclists with cargo bikes, multiple high-end bikes, or those who want to create a dedicated bike maintenance space.\n\n' +
			"Consider your bike's dimensions when choosing. Measure length, height, and width, including any accessories. Also, think about future needs – if you're likely to add more bikes or gear, sizing up initially might save money in the long run compared to upgrading later.",
	},
	{
		question: 'Can I store my bike in a vertical storage unit?',
		answer:
			'Storing bikes vertically in a standard storage unit is definitely doable and often recommended for maximizing space. You can hang bikes on wall hooks, use ceiling-mounted pulley systems, or employ bike stands that hold bicycles upright. This approach works particularly well in taller units where you can take advantage of vertical space. Wall-mounted bike hooks are the most popular solution, allowing you to hang bikes by their wheels or frames.\n\n' +
			"However, before implementing vertical storage, check your storage facility's policies. Some facilities allow wall modifications for hooks or brackets, while others may prohibit drilling into walls. Many facilities now offer bike-specific storage solutions or allow removable hanging systems that don't require permanent installation.\n\n" +
			"Consider your bike's weight and your physical ability to lift it. Standard bikes are manageable for most people, but e-bikes, cargo bikes, or heavy mountain bikes might be challenging to lift repeatedly. Also, ensure you have adequate ceiling height – most storage units have 8-10 foot ceilings, which is typically sufficient for vertical bike storage.\n\n" +
			"If your facility doesn't allow wall modifications, consider portable bike stands or floor-to-ceiling tension pole systems that can hold bikes vertically without permanent installation. These solutions maximize your storage space while keeping bikes organized and easily accessible.",
	},
	{
		question: 'How do I prepare my bike for winter storage?',
		answer:
			'Start with a thorough cleaning to remove all dirt, salt, and debris that could cause corrosion. Pay special attention to the chain, gears, and any metal components.\n\n' +
			'Clean and lubricate the chain with appropriate bike lubricant, but wipe away excess to prevent dirt accumulation. Check and properly inflate tires, or consider slight over-inflation as tires lose pressure over time. For long-term storage, hanging the bike or using a bike stand prevents flat spots.\n\n' +
			'If you have an e-bike, [remove the battery](https://www.sparefoot.com/blog/proper-storage-tips-for-vehicle-batteries) and store it separately in a cool, dry place. Maintain the battery charge at around 40-60% for optimal storage health. Check all cables and housing for damage, and consider having any needed repairs done before storage rather than after.\n\n' +
			'Finally, cover your bike with a breathable cover and store it in a dry, well-ventilated area. Avoid damp basements or areas with temperature fluctuations. Before your first spring ride, check all components, re-lubricate the chain, and ensure everything is working properly.',
	},
];

export const BicycleContent = {
	type: 'Bicycle',
	sections: [
		{
			title: 'bicycle Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'bicycle-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Bike Storage For You',
							image: BicycleHero,
							description:
								'Let’s face it. Bikes are awkward to store, tempting to thieves, and surprisingly vulnerable to damage even when kept indoors. That $2,000 mountain bike or $4,000 e-bike deserves better than being relegated to a corner where it collects dust and gets dinged by car doors. \n\n' +
								'Bicycle storage units are a simple and accessible solution to a problem thousands of apartment dwellers, homeowners, and cyclists share. SpareFoot can connect you to storage facilities that offer bike storage lockers and storage units sized perfectly for your ride and accessories.',
							CTAText: 'Find Storage Now',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Bicycle Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'Stop Spinning Your Wheels: Bicycle Storage Makes Perfect Sense',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Stop Spinning Your Wheels: Bicycle Storage Makes Perfect Sense',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"Professional bicycle storage isn't just about convenience – it's a smart investment in your bikes, your space, and your peace of mind. Whether you're looking to [declutter your home](https://www.sparefoot.com/blog/how-to-declutter-your-home), protect valuable equipment, or simply ensure your bikes are ready to ride when you are, dedicated bike storage delivers benefits that go far beyond just freeing up space.",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'bicycle-storage-benefits',
						headers: [
							{
								label: 'Benefit',
								key: 'Benefit',
							},
							{
								label: 'How Storage Helps',
								key: 'How Storage Helps',
							},
							{
								label: 'Who It Helps Best',
								key: 'Who It Helps Best',
							},
						],
						rows: [
							{
								Benefit: {
									type: 'icon',
									icon: cameraIcon,
									heading: 'Theft Protection',
								},
								'How Storage Helps':
									'Secure facilities with surveillance and controlled access',
								'Who It Helps Best':
									'Urban cyclists, high-value bike owners, and apartment dwellers',
							},
							{
								Benefit: {
									type: 'icon',
									icon: weatherIcon,
									heading: 'Weather Shield',
								},
								'How Storage Helps':
									'Climate-controlled environment prevents rust and component damage',
								'Who It Helps Best':
									'Cyclists in humid climates, carbon fiber bike owners, and long-term storage needs',
							},
							{
								Benefit: {
									type: 'icon',
									icon: garageicon,
									heading: 'Space Liberation',
								},
								'How Storage Helps':
									'Reclaim 6-8 square feet per bike from your living space',
								'Who It Helps Best':
									'Small apartment dwellers, families with multiple bikes, and home organization enthusiasts',
							},
							{
								Benefit: {
									type: 'icon',
									icon: twentyFourHourIcon,
									heading: 'Seasonal Flexibility',
								},
								'How Storage Helps': {
									type: 'markdown',
									markdown:
										'Store road bikes in winter, fat [bikes in summer](https://www.sparefoot.com/blog/properly-store-outdoor-summer-toys)',
								},
								'Who It Helps Best':
									'Multi-bike owners, seasonal cyclists, and weather-dependent riders',
							},
							{
								Benefit: {
									type: 'icon',
									icon: paperIcon,
									heading: 'Insurance Benefits',
								},
								'How Storage Helps':
									'Professional storage often provides better coverage options',
								'Who It Helps Best':
									'High-value bike collections, cyclists without adequate home coverage',
							},
							{
								Benefit: {
									type: 'icon',
									icon: renovatingIcon,
									heading: 'Maintenance Convenience',
								},
								'How Storage Helps':
									'Clean storage conditions reduce wear and pre-ride prep',
								'Who It Helps Best':
									'Busy cyclists, pristine bike enthusiasts, time-conscious commuters',
							},
						],
					},
				},
			],
		},
		{
			title: 'Bicycle Storage Unit Size Guide',
			noPaddingTop: true,
			modules: [
				{
					type: 'content',
					props: {
						title: 'Bicycle Storage Unit Size Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'Do you want room in your bicycle storage unit for just your bike, or do you need space for accessories, seasonal gear, and other equipment? \n\n' +
								'Here are the [most popular storage unit sizes](https://www.sparefoot.com/storage-unit-size-guide.html) for bikes that can accommodate your two-wheeled transportation and plenty of other gear:',
						],
					},
				},
				{
					type: 'unitList',
					props: {
						slug: 'bicycle-storage-size-guide',
						headerLinkText: 'Compare Sizes',
						headerLink: '#bicycle-storage-size-guide',
						scrollFactor: 0.8,
						unitsData: [
							{
								image: bicycleFiveByFive,
								newlayout: false,
								content:
									'### 5x5 Storage Unit\n\n' +
									'**Perfect for:** Single bike with access\n\n' +
									'**Accommodates:** 1-2 standard bicycles\n\n' +
									'**Great for:** Road bikes, hybrid bikes, folding bikes\n\n' +
									'**Bonus space:** Room for helmets, locks, and basic maintenance supplies',
							},
							{
								image: bicycleFiveByTen,
								newlayout: false,
								content:
									'### 5x10 Storage Unit\n\n' +
									'**Perfect for:** Multiple bikes or bikes with extensive gear\n\n' +
									'**Accommodates:** 2-4 bicycles, depending on size\n\n' +
									'**Great for:** Family bike collections, touring bikes with panniers\n\n' +
									'**Bonus space:** Plenty of room for cycling gear, tools, and spare parts',
							},
							{
								image: bicycleTenByTen,
								newlayout: false,
								content:
									'### 10x10 Storage Unit\n\n' +
									'**Perfect for:** Large bike collections or bikes with trailers\n\n' +
									'**Accommodates:** 4-6 bicycles or bikes with child trailers\n\n' +
									'**Great for:** Cycling enthusiasts, families with multiple bikes\n\n' +
									'**Bonus space:** Room for maintenance station, seasonal gear, and bike accessories',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"**Pro Tip:** Measure your bike's length and height before choosing a unit. Don't forget to account for any accessories like pedals, baskets, lights, or bike racks that might affect your storage needs!",
						],
					},
				},
			],
		},
		{
			title: 'Outdoor Bicycle Storage vs. Indoor Bicycle Storage Units',
			background: 'yellow',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Outdoor Bicycle Storage vs. Indoor Bicycle Storage Units',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'The bicycle storage solutions available give you the choice between outdoor bike storage and indoor storage units for bikes, depending on your budget and specific storage requirements. The best outdoor bicycle storage solutions provide an affordable storage space with basic weather protection and convenient access.',
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'column-type',
						ShowBackgroundImage: true,
						content: [
							'### Bicycle Storage Lockers (Outdoor Storage) \n\n' +
								'**Perfect for:** Budget-conscious storage with weather protection \n\n' +
								'**Accommodates:** 1-2 bikes, depending on locker size \n\n' +
								'**Great for:** Seasonal storage, frequent access needs \n\n' +
								'**Benefits:** Drive-up convenience, lower cost than indoor units',
							'### Premium Indoor Storage \n\n' +
								'**Perfect for:** High-value bicycles and comprehensive protection \n\n' +
								'**Accommodates:** Custom sizing available \n\n' +
								'**Great for:** Carbon fiber bikes, e-bikes, or collector bicycles \n\n' +
								'**Benefits:** Climate control, enhanced security, bike-specific services',
						],
					},
				},
			],
		},
		{
			title: 'Bicycle Storage Pricing Guide',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Bicycle Storage Pricing Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							"There's a bike storage solution for every budget. Check out the latest average prices for bicycle storage based on unit size, indoor vs outdoor storage, and what you can get for your money.",
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'bicycle-storage-pricing',
						headers: [
							{
								label: 'Storage Option',
								key: 'Storage Option',
							},
							{
								label: 'Average Monthly Rate',
								key: 'Average Monthly Rate',
							},
							{
								label: 'Best For',
								key: 'Best For',
							},
						],
						rows: [
							{
								'Storage Option': '5x5 Indoor Unit',
								'Average Monthly Rate': '$45/month',
								'Best For': 'Single bike, basic accessories',
							},
							{
								'Storage Option': '5x10 Indoor Unit',
								'Average Monthly Rate': '$65/month',
								'Best For': 'Multiple bikes, cycling gear',
							},
							{
								'Storage Option': '10x10 Indoor Unit',
								'Average Monthly Rate': '$89/month',
								'Best For':
									'Large collections, maintenance space',
							},
							{
								'Storage Option':
									'Bicycle Storage Lockers Outdoor',
								'Average Monthly Rate': '$35/month',
								'Best For': 'Budget storage, seasonal use',
							},
							{
								'Storage Option': 'Premium Indoor Storage',
								'Average Monthly Rate': '$125/month',
								'Best For': 'High-value bikes, climate control',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							'### Additional Fees \n\n' +
								"Your bicycle storage unit or outdoor locker may come with one-time fees in addition to your monthly rate. Be on the lookout for these fees to avoid any surprises when it's time to check in to your unit. \n\n" +
								'- One-time setup fee: $20 average\n' +
								"- Security deposit: Typically equates to one month's rent\n",
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						reviews,
						title: 'Join Others in Choosing SpareFoot for Your Bicycle Storage Search',
					},
				},
			],
		},
		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Bicycle Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			background: 'gray',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'rv-featured-content',
						contentCards: [
							{
								title: 'How to Store It',
								date: 'October 24, 2025',
								image: bicycleFeatured1,
								content:
									'SpareFoot’s Guide to Long-Term Bicycle Storage',
								link: 'https://www.sparefoot.com/blog/long-term-bicycle-storage',
							},
							{
								title: 'General Storage Advice',
								date: 'October 17, 2024',
								image: bicycleFeatured2,
								content:
									'What Can You Fit Inside of a 5×5 Storage Unit?',
								link: 'https://www.sparefoot.com/blog/5x5-storage-unit-size-guide',
							},
							{
								title: 'General Storage Advice',
								date: 'September 24, 2025',
								image: bicycleFeatured3,
								content:
									'What Can You Fit Inside of a 5×10 Storage Unit?',
								link: 'https://www.sparefoot.com/blog/5x10-storage-unit-size-guide',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'Vehicle',
							'Motorcycle',
							'Kayak',
							'DirtBike',
							'College',
							'24Hour',
							'ClimateControl',
							'Electricity',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
	storageType: 'Bicycle',
};
